module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_MURS_PNO7_ROUGE_ROSSO_HORIZONTALE.774b9da5.png";